import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dueState'
})
export class DueStatePipe implements PipeTransform {
  transform(dueDate: Date, todaysDate: Date): string {
    const difference = dueDate.getTime() - todaysDate.getTime();
    if (difference <= 0) {
      return 'Bereit zur Wiederholung';
    }

    const hours = Math.floor(difference / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);

    // Wenn innerhalb von Morgen
    const today = new Date(todaysDate);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(today.getDate() + 2);

    if (dueDate.toDateString() === tomorrow.toDateString()) {
      return 'Morgen';
    } else if (dueDate.toDateString() === dayAfterTomorrow.toDateString()) {
      return 'Übermorgen';
    }

    if (months > 0) {
      return `In ${months} Monat${months > 1 ? 'en' : ''}`;
    } else if (days > 0) {
      return `In ${days} Tag${days > 1 ? 'en' : ''}`;
    } else {
      return `In ${hours > 0 ? hours : 1} Stunde${(hours > 1 || hours === 0) ? 'n' : ''}`;
    }
  }
}